import { createContext } from 'react';
import { defaultCrmObjectPreviewModalContextProps } from './constants';
export const PreviewModalPropsContext = /*#__PURE__*/createContext(defaultCrmObjectPreviewModalContextProps);